import React, { Component } from 'react';
import logo from './c_swimming.png';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <a href="https://team.commitswimming.com"><img src={logo} className="App-logo" alt="logo" /></a>
        </header>
        <p className="App-intro">
          Commit's Team Suite has moved to <a href="https://team.commitswimming.com">https://team.commitswimming.com</a>.
        </p>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js